"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _find = _interopRequireDefault(require("lodash/find"));

var _toLower = _interopRequireDefault(require("lodash/toLower"));

var _Skeleton = _interopRequireDefault(require("@eig-builder/core-ui/Skeleton"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _string = _interopRequireDefault(require("./../components/fields-without-deps/string"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  margin-top: ", "px !important;\n  margin-bottom: ", "px !important;\n  margin-left: ", "px;\n  width: calc(100% - ", "px);\n  height: 40px !important;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Email = _react["default"].lazy(function () {
  return import(
  /* webpackChunkName: "field-Email" */
  './../components/fields-without-deps/email');
});

var Number = _react["default"].lazy(function () {
  return import(
  /* webpackChunkName: "field-Number" */
  './../components/fields-without-deps/number');
});

var Phone = _react["default"].lazy(function () {
  return import(
  /* webpackChunkName: "field-Phone" */
  './../components/fields-without-deps/phone');
});

var Password = _react["default"].lazy(function () {
  return import(
  /* webpackChunkName: "field-Password" */
  './../components/fields-without-deps/password');
});

var Textarea = _react["default"].lazy(function () {
  return import(
  /* webpackChunkName: "field-Textarea" */
  './../components/fields-without-deps/textarea');
});

var Toggle = _react["default"].lazy(function () {
  return import(
  /* webpackChunkName: "field-Toggle" */
  './../components/fields-without-deps/toggle');
});

var Slider = _react["default"].lazy(function () {
  return import(
  /* webpackChunkName: "field-Slider" */
  './../components/fields-without-deps/slider');
});

var Radio = _react["default"].lazy(function () {
  return import(
  /* webpackChunkName: "field-Radio" */
  './../components/fields-without-deps/radio');
});

var Checkbox = _react["default"].lazy(function () {
  return import(
  /* webpackChunkName: "field-Checkbox" */
  './../components/fields-without-deps/checkbox');
});

var Agreement = _react["default"].lazy(function () {
  return import(
  /* webpackChunkName: "field-Agreement" */
  './../components/fields-without-deps/agreement');
});

var FieldGroup = _react["default"].lazy(function () {
  return import(
  /* webpackChunkName: "field-group" */
  './../components/fields-without-deps/field-group');
});

var fieldTypeAlias = {
  imageupload: 'imagesuploader',
  tagsinput: 'tags'
};
var StyledSkeleton = (0, _styledComponents["default"])(_Skeleton["default"])(_templateObject(), function (props) {
  return props.theme.spacing(2);
}, function (props) {
  return props.theme.spacing(2);
}, function (props) {
  return props.theme.spacing(4);
}, function (props) {
  return props.theme.spacing(4);
});

var PlaceHolderField = function PlaceHolderField(_ref) {
  var skeletonLoader = _ref.skeletonLoader;

  if (skeletonLoader) {
    return /*#__PURE__*/_react["default"].createElement(StyledSkeleton, null);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: 56
    }
  }, "\xA0");
};

PlaceHolderField.propTypes = {
  skeletonLoader: _propTypes["default"].bool
};
/**
 * Field resolver, resolves field definition into react element
 *
 * @class FieldResolver
 */

var FieldResolver = /*#__PURE__*/function () {
  function FieldResolver() {
    (0, _classCallCheck2["default"])(this, FieldResolver);
  }

  (0, _createClass2["default"])(FieldResolver, [{
    key: "resolve",

    /**
     * Resolve field definition into react element
     *
     * @param {object} field definition
     * @param {object} schema definition
     * @param {Array} optional hideFieldsByName, hide fields that are in this field
     * @returns {element} React element, could be null when the field is hidden or has a unknown type
     *
     * @memberOf FieldResolver
     */
    value: function resolve(field, value, additionalFieldTypes, skeletonLoader) {
      try {
        if (!this.validateField(field)) {
          return /*#__PURE__*/_react["default"].createElement("h5", {
            key: field.name
          }, "invalid field: ", JSON.stringify(field));
        }

        var typeStr = field.type.toLowerCase(); // handle alias fieldtype

        var type = fieldTypeAlias[typeStr] || typeStr; // map server readonly field to react form readonly

        var readOnly = field.readonly;

        if (field.controlClass) {
          var ControlClass = field.controlClass;
          return /*#__PURE__*/_react["default"].createElement(ControlClass, (0, _extends2["default"])({
            key: field.name,
            readOnly: readOnly,
            field: field
          }, field, {
            value: value
          }));
        }

        if (type === 'hidden') {
          return null;
        }

        if (additionalFieldTypes) {
          var fieldType = (0, _find["default"])(additionalFieldTypes, function (obj) {
            return obj.type === type;
          });

          if (fieldType) {
            return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
              key: field.name,
              fallback: /*#__PURE__*/_react["default"].createElement(PlaceHolderField, (0, _extends2["default"])({
                skeletonLoader: skeletonLoader,
                readOnly: true
              }, field, {
                value: value
              }))
            }, /*#__PURE__*/_react["default"].createElement(fieldType.LazyComponent, (0, _extends2["default"])({
              readOnly: readOnly
            }, field, {
              value: value
            })));
          }
        }

        switch (type) {
          case 'string':
            return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
              key: field.name,
              fallback: /*#__PURE__*/_react["default"].createElement(PlaceHolderField, (0, _extends2["default"])({
                skeletonLoader: skeletonLoader,
                readOnly: true
              }, field, {
                value: value
              }))
            }, /*#__PURE__*/_react["default"].createElement(_string["default"], (0, _extends2["default"])({
              readOnly: readOnly
            }, field, {
              value: value
            })));

          case 'email':
            return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
              key: field.name,
              fallback: /*#__PURE__*/_react["default"].createElement(PlaceHolderField, (0, _extends2["default"])({
                skeletonLoader: skeletonLoader,
                readOnly: true
              }, field, {
                value: value
              }))
            }, /*#__PURE__*/_react["default"].createElement(Email, (0, _extends2["default"])({
              readOnly: readOnly
            }, field, {
              value: value
            })));

          case 'password':
            return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
              key: field.name,
              fallback: /*#__PURE__*/_react["default"].createElement(PlaceHolderField, (0, _extends2["default"])({
                skeletonLoader: skeletonLoader,
                readOnly: true
              }, field, {
                value: value
              }))
            }, /*#__PURE__*/_react["default"].createElement(Password, (0, _extends2["default"])({
              readOnly: readOnly
            }, field, {
              value: value
            })));

          case 'number':
            return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
              key: field.name,
              fallback: /*#__PURE__*/_react["default"].createElement(PlaceHolderField, (0, _extends2["default"])({
                skeletonLoader: skeletonLoader,
                readOnly: true
              }, field, {
                value: value
              }))
            }, /*#__PURE__*/_react["default"].createElement(Number, (0, _extends2["default"])({
              readOnly: readOnly
            }, field, {
              value: value
            })));

          case 'phone':
            return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
              key: field.name,
              fallback: /*#__PURE__*/_react["default"].createElement(PlaceHolderField, (0, _extends2["default"])({
                skeletonLoader: skeletonLoader,
                readOnly: true
              }, field, {
                value: value
              }))
            }, /*#__PURE__*/_react["default"].createElement(Phone, (0, _extends2["default"])({
              readOnly: readOnly
            }, field, {
              value: value
            })));

          case 'textarea':
            return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
              key: field.name,
              fallback: /*#__PURE__*/_react["default"].createElement(PlaceHolderField, (0, _extends2["default"])({
                skeletonLoader: skeletonLoader,
                readOnly: true
              }, field, {
                value: value
              }))
            }, /*#__PURE__*/_react["default"].createElement(Textarea, (0, _extends2["default"])({
              readOnly: readOnly
            }, field, {
              value: value
            })));

          case 'boolean':
            return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
              key: field.name,
              fallback: /*#__PURE__*/_react["default"].createElement(PlaceHolderField, {
                skeletonLoader: skeletonLoader
              })
            }, /*#__PURE__*/_react["default"].createElement(Toggle, (0, _extends2["default"])({
              key: field.name,
              readOnly: readOnly
            }, field, {
              value: value
            })));

          case 'slider':
            return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
              key: field.name,
              fallback: /*#__PURE__*/_react["default"].createElement(PlaceHolderField, {
                skeletonLoader: skeletonLoader
              })
            }, /*#__PURE__*/_react["default"].createElement(Slider, (0, _extends2["default"])({
              key: field.name,
              readOnly: readOnly
            }, field, {
              value: value
            })));

          case 'radio':
            return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
              key: field.name,
              fallback: /*#__PURE__*/_react["default"].createElement(PlaceHolderField, {
                skeletonLoader: skeletonLoader
              })
            }, /*#__PURE__*/_react["default"].createElement(Radio, (0, _extends2["default"])({
              key: field.name,
              readOnly: readOnly
            }, field, {
              value: value
            })));

          case 'checkbox':
            return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
              key: field.name,
              fallback: /*#__PURE__*/_react["default"].createElement(PlaceHolderField, {
                skeletonLoader: skeletonLoader
              })
            }, /*#__PURE__*/_react["default"].createElement(Checkbox, (0, _extends2["default"])({
              key: field.name,
              readOnly: readOnly
            }, field, {
              value: value
            })));

          case 'agreement':
            return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
              key: field.name,
              fallback: /*#__PURE__*/_react["default"].createElement(PlaceHolderField, {
                skeletonLoader: skeletonLoader
              })
            }, /*#__PURE__*/_react["default"].createElement(Agreement, (0, _extends2["default"])({
              key: field.name,
              readOnly: readOnly
            }, field, {
              value: value
            })));

          case 'fieldgroup':
            return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
              key: field.name,
              fallback: /*#__PURE__*/_react["default"].createElement(PlaceHolderField, {
                skeletonLoader: skeletonLoader
              })
            }, /*#__PURE__*/_react["default"].createElement(FieldGroup, (0, _extends2["default"])({
              doNotRegisterMe: true,
              key: field.name,
              fields: field.fields
            }, field)));
        }

        return /*#__PURE__*/_react["default"].createElement("h6", {
          key: field.name,
          className: "core-field-components-fields-field col-12 p-4",
          style: {
            height: '16px',
            marginTop: '24px',
            fontStyle: 'normal'
          }
        }, "Can't resolve field type: ", field.type, ", did you forget to add @eig-builder/module-property-editor-field-", (0, _toLower["default"])(field.type), "?");
      } catch (ex) {
        console.error(ex);
      }
    }
    /**
     * Validate field - make sure that field.type is defined
     *
     * @param {object} field definition
     * @returns {bool} is valid
     *
     * @memberOf FieldResolver
     */

  }, {
    key: "validateField",
    value: function validateField(field) {
      if (field && field.type) {
        return true;
      }

      return false;
    }
  }]);
  return FieldResolver;
}();

var instance = new FieldResolver();
var _default = instance;
exports["default"] = _default;